import { Text } from '@oneaudi/unified-web-components';
import { TextVariant } from 'node_modules/@oneaudi/unified-web-components/dist/esm/components/text';
import { ReactNode } from 'react';
import { useI18n } from '~/app/i18n/i18n';
import { PriceSectionStyle } from '~/app/pages/summary/dialogs/price-detail/components/price-section-style';
import { useFootnotes } from '~/components/footnotes';
import { FootnoteReferenceNgc } from '~/components/footnotes/footnote-reference';

export function PriceSection({
	pricePartType,
	title,
	subtitle,
	price,
	bold,
	disclaimer,
	variant,
	order,
}: {
	pricePartType: string;
	/** Translated title of this section.  */
	title: string | ReactNode;
	/** Translated subtilte of this section.  */
	subtitle?: string | ReactNode;
	/** Formatted price of this part. */
	price: string | null | undefined;
	bold?: boolean;
	disclaimer: string | null | undefined;
	variant?: TextVariant['type'];
	order?: TextVariant['order'];
}) {
	const { i18n, i18nKeys } = useI18n();
	const { registerFootnote } = useFootnotes();

	const i18nKey = `ngc.remarks.pricePart.${pricePartType}` as keyof typeof i18nKeys;
	const footnoteReference = i18nKey in i18nKeys ? registerFootnote(i18nKey, i18n(i18nKey)) : null;
	const disclaimerReference = disclaimer ? registerFootnote('p-disclaimer', disclaimer) : null;
	return (
		<PriceSectionStyle>
			<Text tag="p" variant={{ type: variant || 'copy', order: order || '2', style: bold ? 'bold' : 'normal' }}>
				{title}
				{subtitle}
				{footnoteReference && <FootnoteReferenceNgc reference={footnoteReference} />}
				{disclaimerReference && <FootnoteReferenceNgc reference={disclaimerReference} />}
			</Text>
			<Text
				className="price"
				tag="p"
				variant={{ type: variant || 'copy', order: order || '2', style: bold ? 'bold' : 'normal' }}>
				{price}
			</Text>
		</PriceSectionStyle>
	);
}
